import { lazy, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { usePageTracking } from "@/hooks/usePageTracking";
import { NewsletterProvider } from "@/contexts/NewsletterContext";

// Lazy load below-the-fold sections
const AboutSection = lazy(() => import("@/components/AboutSection").then(m => ({ default: m.AboutSection })));
const NewsSection = lazy(() => import("@/components/NewsSection").then(m => ({ default: m.NewsSection })));
const TeamSection = lazy(() => import("@/components/TeamSection").then(m => ({ default: m.TeamSection })));
const AdvisoryBoardSection = lazy(() => import("@/components/AdvisoryBoardSection").then(m => ({ default: m.AdvisoryBoardSection })));
const MoviNumbersSection = lazy(() => import("@/components/MoviNumbersSection").then(m => ({ default: m.MoviNumbersSection })));
const MeetingSection = lazy(() => import("@/components/MeetingSection").then(m => ({ default: m.MeetingSection })));
const SupportersSection = lazy(() => import("@/components/SupportersSection").then(m => ({ default: m.SupportersSection })));
const ContactSection = lazy(() => import("@/components/ContactSection").then(m => ({ default: m.ContactSection })));
const NewsletterPopup = lazy(() => import("@/components/NewsletterPopup").then(m => ({ default: m.NewsletterPopup })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));

const Index = () => {
  usePageTracking();

  return (
    <NewsletterProvider>
      <div className="min-h-screen bg-background">
        <Navbar />
        <main>
          <HeroSection />
          <Suspense fallback={null}>
            <AboutSection />
            <NewsSection />
            <TeamSection />
            <AdvisoryBoardSection />
            <MoviNumbersSection />
            <MeetingSection />
            <SupportersSection />
            <ContactSection />
          </Suspense>
        </main>
        <Suspense fallback={null}>
          <Footer />
          <NewsletterPopup />
        </Suspense>
      </div>
    </NewsletterProvider>
  );
};

export default Index;